import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Card, Badge, Th, Td, Empty, fmtDate } from "./ui";
import { Search } from "lucide-react";

const STATUSES = ["", "pending", "pending_business_verification", "pending_payment", "paid", "failed", "canceled", "expired"];

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");
  const navigate = useNavigate();

  const load = () => api.get("/admin/orders", { params: { q, status } }).then((r) => setOrders(r.data)).catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [status]);

  return (
    <div>
      <PageHeader title="Orders" subtitle="Beheer zakelijke bestellingen" />
      <div className="mb-5 flex flex-wrap gap-3">
        <form onSubmit={(e) => { e.preventDefault(); load(); }} className="relative flex-1 min-w-[240px]">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
          <input data-testid="orders-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Zoek op ordernr, bedrijf of KvK..." className="w-full rounded-full border border-white/10 bg-white/[0.03] py-2.5 pl-9 pr-4 text-sm text-white placeholder:text-white/40 focus:border-sfc-orange focus:outline-none" />
        </form>
        <select data-testid="orders-status-filter" value={status} onChange={(e) => setStatus(e.target.value)} className="rounded-full border border-white/10 bg-white/[0.03] px-4 py-2.5 text-sm text-white focus:outline-none">
          {STATUSES.map((s) => <option key={s} value={s}>{s ? s.replace(/_/g, " ") : "Alle statussen"}</option>)}
        </select>
      </div>

      <Card>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="border-b border-white/10"><tr><Th>Ordernr</Th><Th>Bedrijf</Th><Th>KvK</Th><Th>Totaal</Th><Th>Status</Th><Th>Datum</Th></tr></thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id} data-testid={`order-row-${o.order_number}`} onClick={() => navigate(`/admin/orders/${o.id}`)} className="cursor-pointer border-b border-white/5 hover:bg-white/[0.03]">
                  <Td className="font-medium text-sfc-orange">{o.order_number}</Td>
                  <Td>{o.customer.company_name}</Td>
                  <Td>{o.customer.kvk_number}</Td>
                  <Td>€{o.totals.total_inc_vat.toFixed(2)}</Td>
                  <Td><Badge status={o.status} /></Td>
                  <Td className="text-white/50">{fmtDate(o.created_at)}</Td>
                </tr>
              ))}
            </tbody>
          </table>
          {orders.length === 0 && <Empty text="Nog geen orders" />}
        </div>
      </Card>
    </div>
  );
}
